import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {ProgressBar} from "primereact/progressbar";
import {classNames} from "primereact/utils";
import {Divider} from "primereact/divider";
import {getAudioControlPermissions} from "../../../../../redux/permissions/permissionsUtils";
import {
    setAudioControlDialogVisible,
    setAudioControlErrorField,
    setSelectedAudioControlIndex,
} from "../../../../../redux/actions/actionsAudioControl";
import {getAudioControlById} from "../../../../../redux/api/apiAudioControl";
import {setEditType} from "../../../../../redux/actions/actions";

const AudioControlListDetails = (props: any) => {
    const dispatch = useAppDispatch();
    const audioControlData = useAppSelector(state => state.AudioControlListReducer.audioControlData);
    const loader = useAppSelector(state => state.AudioControlListReducer.detailsLoading);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const permissions = getAudioControlPermissions(rolesVision);
    const archiveTableToggle = useAppSelector(state => state.AudioControlListReducer.archiveAudioControlTableToggle);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const branches = useAppSelector(state => state.UsersListReducer.branches);

    const {
        update: hasUpdatePermission,
    } = permissions;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const branchName = () => {
        const branch = branches?.find((item: { id: number }) => item?.id === audioControlData?.branchId);
        return branch ? `${branch.id} ${branch.name}` : '- - -';
    };

    const fields = [
        {label: "ID", value: audioControlData?.id},
        {label: "Стан", value: audioControlData?.isActive ? 'Активна' : 'Не активна'},
        {label: "Бранч", value: branchName()},
        {label: "Опис", value: audioControlData?.description || '- - -'},
    ];

    const openEditor = () => {
        dispatch(setSelectedAudioControlIndex(audioControlData?.id ?? props.selectedRowData));
        dispatch(setAudioControlDialogVisible(true));
        dispatch(setAudioControlErrorField(null));
        dispatch(getAudioControlById(props.selectedRowData, jwtToken?.jwtToken));
        if (hasUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    }

    return (
        <div className="">
            <div className="relative">
                {loader && <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>}
                <div className={classNames('grid', {'opacity-50': loader})} style={{paddingTop: "0.3rem", padding: '0.3rem 10px 5px'}}>
                    {windowWidth > 1248 && <div className="grid col-12 md:col-12 mb-0 flex justify-content-between">
                        <div className="field col-12 md:col-6 flex align-items-center flex-wrap m-0">
                            <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                <p className="w-full">ID: {audioControlData?.id}</p>
                            </div>
                            <div className="field col-12 md:col-8 flex align-items-center m-0 p-0">
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                <p className="w-full">{audioControlData?.name}</p>
                            </div>
                        </div>
                        <div className="col-12 md:col-5 flex align-items-center m-0 p-0 justify-content-end text-right">
                            <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 p-0">
                            </div>
                            <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 p-0">
                                <p className="w-full">{audioControlData?.isActive ? 'Активна' : 'Не активна'}</p>
                            </div>
                            <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                                <button className="close-button block cursor-pointer mr-1" onClick={() => {
                                    openEditor();
                                }}><span className={classNames('', {
                                    'pi pi-pencil': archiveTableToggle && hasUpdatePermission,
                                    'pi pi-eye': !archiveTableToggle || !hasUpdatePermission
                                })}></span></button>
                                <button className="close-button block cursor-pointer ml-0" onClick={() => props.setSelectedRowData(null)}><span className="pi pi-times"></span></button>
                            </div>
                        </div>
                    </div>}
                    {windowWidth <= 1248 && <div className="grid col-12 md:col-12 mb-0 px-0">
                        <div className="field col-12 md:col-12 flex align-items-center m-0">
                            <p className="w-full">{audioControlData?.name}</p>
                        </div>
                        {(<div className="field col-12 md:col-12 p-0" style={{margin: 0, borderBottom: '1px solid #cccccc38'}}></div>)}
                    </div>}
                    {windowWidth <= 1248 && <>
                        {fields.map((field: any) => (
                            <React.Fragment key={field.label}>
                                <div className="field col-4 md:col-6 flex align-items-start m-0">
                                    <p>{field.label}</p>
                                </div>
                                <div className="field col-8 md:col-6 flex align-items-start m-0">
                                    <p>{field.value}</p>
                                </div>
                            </React.Fragment>
                        ))}
                    </>}
                    {windowWidth > 1248 &&
                        <React.Fragment>
                            <Divider className="my-0"/>
                            <div className="field col-12 md:col-12 flex align-items-center m-0">
                                <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                    <p className="w-full">Бранч</p>
                                </div>
                                <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                    <p className="w-full">Опис</p>
                                </div>
                            </div>
                            <Divider className="my-0"/>
                            <div className="field col-12 md:col-12 flex m-0 scroll-detail-items">
                                <div className="field col-12 md:col-4 flex m-0 p-0">
                                    {branchName()}
                                </div>
                                <div className="field col-12 md:col-4 flex m-0 p-0">
                                    {audioControlData?.description || '- - -'}
                                </div>
                            </div>
                        </React.Fragment>
                    }
                </div>
            </div>
        </div>
    )
}

export default AudioControlListDetails;
